import qs from "qs";

export class RuejaiClubVoucherPackageClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/packages`;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/voucher${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async post(params) {
    const url = `${this.baseURL}/voucher`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async updateOrder(params) {
    const url = `${this.baseURL}/voucher`;

    const requestParams = { ...params };
    if (requestParams.order === '') {
      requestParams.order = null;
    }
    const response = await this.httpClient.request("put", url, {
      data: requestParams
    });

    return response;
  }
}
